import AuthenticationService from './AuthenticationService.js';

const authenticationService = new AuthenticationService();
export default authenticationService;